import { render, staticRenderFns } from "./userLinkBtn.vue?vue&type=template&id=face0d22"
import script from "./userLinkBtn.vue?vue&type=script&lang=js"
export * from "./userLinkBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports